import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { BPASettings } from '@models/bpa-settings';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { GlobalStateProviderService } from './global-state-provider.service';

@Injectable({
  providedIn: 'root'
})
export class BpaSettingsService {
  constructor(
    private readonly http: HttpClient,
    private readonly globalStateProviderService: GlobalStateProviderService
  ) {}

  loadBpaSettings(): Observable<BPASettings> {
    const cachedData = this.globalStateProviderService.getCachedBpaSettings();
    const now = Date.now();

    if (
      cachedData &&
      (!environment.BPA_SETTINGS_CACHE_DURATION_MS ||
        now - cachedData.timestamp < environment.BPA_SETTINGS_CACHE_DURATION_MS)
    ) {
      return of(cachedData.settings);
    }

    return this.http
      .get<BPASettings>(
        `${environment.RESTHEART_URL}documents/settings/defaults`
      )
      .pipe(
        tap((settings) => {
          this.globalStateProviderService.updateBpaSettings(settings);
        })
      );
  }

  /**
   * Get an observable of the BPA settings
   * This allows components to subscribe to changes in the settings
   */
  getBpaSettings$(): Observable<BPASettings | null> {
    return this.globalStateProviderService.bpaSettings$;
  }

  /**
   * Force refresh the BPA settings from the server
   * This is useful when you know the settings have changed on the server
   * or when the cache has expired
   */
  refreshBpaSettings(): Observable<BPASettings> {
    return this.http
      .get<BPASettings>(
        `${environment.RESTHEART_URL}documents/settings/defaults`
      )
      .pipe(
        tap((settings) => {
          this.globalStateProviderService.updateBpaSettings(settings);
        })
      );
  }
}
